import script from "./PatientsDatatableFormSnils.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientsDatatableFormSnils.vue?vue&type=script&setup=true&lang=js"

import "./PatientsDatatableFormSnils.vue?vue&type=style&index=0&id=2d18e7ca&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d18e7ca"]])

export default __exports__